import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-azure-ri',
  templateUrl: './confirm-azure-ri.component.html',
  styleUrls: ['./confirm-azure-ri.component.css'],
})
export class ConfirmAzureRiComponent implements OnInit {
  azureRiPoReference: string;

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmAzureRiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  continueSaveAzureRi(): void {
    if (!this.azureRiPoReference) {
      this.commonService.showError(
        '.poReference',
        'Po reference can not be empty',
        'right'
      );
      return;
    }
    if (/\s/.test(this.azureRiPoReference)) {
      this.commonService.showError(
        '.poReference',
        'Po reference can not contain any spaces',
        'right'
      );
      return;
    }
    this.dialogRef.close(this.azureRiPoReference);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
